<template>
    <div class="embed">
        <iframe
            v-if="url"
            :src="url"
            loading="lazy"
            width="100%"
            :height="height"
            frameborder="0"
            allowfullscreen="true"
            referrerpolicy="origin"
            sandbox="allow-forms allow-modals allow-popups allow-scripts allow-top-navigation-by-user-activation"
        />
    </div>
</template>

<script setup>
defineProps({
    url: {
        type: String,
        required: true,
        default: ''
    },
    height: {
        type: String,
        required: false,
        default: 'auto'
    }
});
</script>
